<app-signature (signEvent)="signEvent($event)"></app-signature>
<div class="w-full z-5 fixed top-0 left-0 flex justify-content-center align-items-center"
     style="height: 100vh; background-color: rgba(0,0,0,0.73);" *ngIf="isSessionExpired">
    <div class="p-6 border-round-xl w-4" style="background-color: var(--primary-500)">
        <div class="text-2xl text-white font-semibold text-center">Ihre Sitzung ist abgelaufen. Bitte klicken Sie auf die Schaltfläche, um sich anzumelden</div>
        <div class="mt-4 flex justify-content-end">
            <p-button label="Login" (click)="reloadThePage()"></p-button>
        </div>
    </div>
</div>
